var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PG_Icon_Download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "results-B",
    transform: "translate(-935.000000, -220.000000)",
    fill: "#2E2D2C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button",
    transform: "translate(910.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PG_Icon_Download",
    transform: "translate(25.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_LIVE",
    transform: "translate(1.125000, 1.125000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "14.625 11.8125 14.625 14.625 1.125 14.625 1.125 11.8125 0 11.8125 0 15.75 15.75 15.75 15.75 11.8125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.975625,8.038125 L8.4375,11.581875 L8.4375,1.125 C8.4375,0.50625 7.93125,0 7.3125,0 L7.3125,11.581875 L3.774375,8.04375 L2.98125,8.836875 L7.875,13.730625 L12.774375,8.83125 L11.975625,8.038125 Z",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.3eaa68c963419cd6aaedf7c3362bdbd1.svg";
export { ForwardRef as ReactComponent };